import Vue from "vue";
import VueRouter from "vue-router";
import { getUsuarioLogado } from "@/db/usuario";
import storeUsuario from "../store/usuario";
import storeSistema from "../store/sistema";
import HomeView from "../views/home/HomeView.vue";
import sistemaRouter from "./sistemaRouter";
import clientesRouter from "./clientesRouter";
import pedidosRouter from "./pedidosRouter";
import relatoriosRouter from "./relatoriosRouter";
import formacaoCargaRouter from "./formacaoCargaRouter";
import { getSincronizacoes } from "@/db/sistema";
import PaginaNaoEncontrada from "@/views/errors/PaginaNaoEncontrada";
import pedidosStore from "@/store/pedidos";
import store from "@/store";
import visitaTecnicaRouter from "./visitaTecnicaRouter";


Vue.use(VueRouter);

const baseRoutes = [
  {
    path: "/",
    name: "Coasul - Nutrição Animal",
    component: HomeView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
    },
  },
  {
    path: "*",
    name: "Coasul - 404",
    component: PaginaNaoEncontrada,
    meta: {
      requiresAuth: true,
      sync: false,
      online: false,
    },
  },
];

const routes = baseRoutes.concat(
  sistemaRouter,
  clientesRouter,
  pedidosRouter,
  relatoriosRouter,
  formacaoCargaRouter,
  visitaTecnicaRouter
);

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  storeSistema.state.loadingApp = true;
  var userLogado = await getUsuarioLogado();
  storeUsuario.mutations.setUsuarioLogado(storeUsuario.state, userLogado);
  if (to.meta.requiresAuth) {
    if (userLogado == null) {
      next("/login");
    } else {
      if (navigator.onLine) {
        storeSistema.actions.validarToken(storeSistema.getters);

        /*Aqui tento sincronizar os pedidos offline*/
        await pedidosStore.actions.sincronizarPedidos(pedidosStore.state);
      }

      if (to.meta.sync) {
        var listaSync = await getSincronizacoes();
        storeSistema.mutations.setSincronizacoes(storeSistema.state, listaSync);
        var syncObrig = storeSistema.getters.precisaSincronizar(
          storeSistema.state,
          storeSistema.getters
        );
        if (syncObrig) {
          next("/sincronizar");
        }
      }

      if (to.meta.device) {
        if (!to.meta.device.includes(storeSistema.getters.device())) {
          next(from.path);
        }
      }

      if(to.meta.cod && to.meta.cod > 0){        
        if(store.state.sistema.atalhos.findIndex((a) => a.operacao == to.meta.cod) < 0){
          next("/")
        }
      }

    }
  } else if (to.path == "/login" && userLogado) {
    next("/");
  }
  next();
  storeSistema.state.loadingApp = false;
});

export default router;
